/**
 * Represents a mobile library object used when no native mobile environment
 * is found, which generally corresponds to mobile web. Many of the methods
 * are stubs; some are implemented when they are needed on features across both
 * mobile web and native.
 *
 * @see WebViewHelper
 * */

export default function MobileWeb() {
  this.type = 'null';
  this.init = function () {};
  this.isInitialized = function () {
    return true;
  };
  this.haveDeviceNavigateTo = function () {};
  this.haveDeviceDeeplinkTo = function (url) {
    window.open(url, '_blank');
  };
  this.reportProgress = function () {};
  this.destroy = function () {};
}
